"use client";

import { Icon, type SupportedIcon } from "@/components/ui/icon";
import { useCurrentUser } from "@/hooks/use-current-user";
import type { DetailedListing, DetailedListingViewAs } from "@/lib/types";
import { buildStepUrl } from "@repo/utils";
import Link from "next/link";
import { useSearchParams } from "next/navigation";

export type ListingEditButtonProps = {
  listing: DetailedListing;
  step: DetailedListing["step"];
  label: string;
  icon?: SupportedIcon;
  className?: string;
};

export function ListingEditButton({
  listing,
  step,
  label,
  icon,
  className,
}: ListingEditButtonProps) {
  const { user } = useCurrentUser();
  const searchParams = useSearchParams();

  const viewAs = searchParams.get("viewAs") as DetailedListingViewAs | null;

  const isOwner =
    user && (user.id === listing.ownerId || user.id === listing.sellerAgentId);

  if (
    !isOwner ||
    (isOwner && (viewAs === "PUBLIC_BUYER" || viewAs === "SECURED_BUYER"))
  ) {
    return null;
  }

  return (
    <div className={className}>
      <Link
        href={buildStepUrl(listing, step)}
        className="inline-flex items-center gap-1.5 text-[13px] text-gray-500 hover:text-foreground transition-colors"
      >
        <Icon icon={icon ?? "Pencil2"} className="size-3.5" />
        {label}
      </Link>
    </div>
  );
}
